import { render, staticRenderFns } from "./MagazineSearch.vue?vue&type=template&id=c12c90f2&scoped=true"
import script from "./MagazineSearch.vue?vue&type=script&lang=js"
export * from "./MagazineSearch.vue?vue&type=script&lang=js"
import style0 from "./MagazineSearch.vue?vue&type=style&index=0&id=c12c90f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12c90f2",
  null
  
)

export default component.exports